import { EndOfJourneyTemplate } from '../../lib/types/models/end-of-journey-template/end-of-journey-template'
import { EndOfJourneyTemplateInput } from '../../lib/types/models/end-of-journey-template/end-of-journey-template-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateEndOfJourneyTemplate({
  id,
  ...data
}: UpdateInput<EndOfJourneyTemplateInput>): Promise<EndOfJourneyTemplate> {
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-templates'].update.url, { id }))
    .patch<EndOfJourneyTemplate, Partial<EndOfJourneyTemplateInput>>(data)
}
